/////////////////////
//// Helper functions

function getUTMParameter(key) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(key) ? urlParams.get(key) : null;
}

function hideElement(el) {
  if (el) el.style.display = "none";
}
function showElement(el, displayStyle) {
  if (el) el.style.display = displayStyle || "block";
}

function addOverlayStatus(text) {
  const textArea = document.getElementById('overlay-text');
  textArea.textContent += (textArea.textContent ? '\n' : '') + text;
}

function showOverlayButtons(label, triggerBtn, originalTriggerBtnText) {
  return new Promise(resolve => {
    const btnContainer = document.getElementById('overlay-buttons');
    btnContainer.innerHTML = '';

    const confirmBtn = document.createElement('button');
    confirmBtn.classList.add("sc-eBHgEO", "iPOMtj", "pf-80_", "pf-button-2");
    confirmBtn.textContent = label;
    confirmBtn.addEventListener('click', (e) => {
      e.preventDefault();
      confirmBtn.style.display = 'none';
      cancelBtn.style.display = 'none';
      resolve();
    });

    const cancelBtn = document.createElement('button');
    cancelBtn.classList.add("sc-eBHgEO", "iPOMtj", "pf-80_", "pf-button-2");
    cancelBtn.style.marginLeft = '10px';
    cancelBtn.textContent = 'Cancel';
    cancelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      triggerBtn.textContent = originalTriggerBtnText;
      document.getElementById('overlay-text').textContent = '';
      document.getElementById('overlay-buttons').innerHTML = '';
      document.getElementById('loading-overlay').style.display = 'none';
    });

    btnContainer.appendChild(confirmBtn);
    btnContainer.appendChild(cancelBtn);
  });
}

/////////////////////
//// Global variables
let topUpAmtArray = "100,500,1000,5000".split(",");
let stripeActiveElements = null;


////////////////////
//// Initialisation
document.addEventListener("DOMContentLoaded", function () {

  // Open the tab if 'tab' UTM parameter set 
  const interval = setInterval(() => {
    const tab = document.querySelector('#container-' + global_device_type + ' #go-premium-tab');
    if (tab) {
      tab.click();
      clearInterval(interval);
    }
  }, 200);
  
  
  document.querySelectorAll('#auto-top-up-threshold input').forEach(el => {
    el.value = 500;
    el.setAttribute("min", 100);
    el.setAttribute("step", 100);
  });

  document.querySelectorAll('#auto-top-up-amount input').forEach(el => {
    el.value = 400;
    el.setAttribute("min", 400);
    el.setAttribute("step", 100);
  });

  hideElement(document.getElementById("otherTopup"));
  hideElement(document.getElementById("otherTriggerTopup"));

  jQuery.getJSON('/cart.js', function(cart) {
    if (cart && cart.items && cart.items[0]) {
      const cartTotalAmount = parseFloat(cart.total_price) / 100;
      const diff = cartTotalAmount - customerCredit;
      if (diff > 0) {
        const initialMin = parseFloat(topUpAmtArray[0]);
        topUpAmtArray[0] = Math.max(initialMin, diff).toString();
      }
    }
    
    init();
  });
});

function init() {
  const minTopUp = parseFloat(topUpAmtArray[0]);

  topUpAmtArray = topUpAmtArray.filter(amount => parseFloat(amount) >= minTopUp);

  initActionsStripe();
  initTopUpValue_pagefly_topup(minTopUp);
  initAutoTopUpValue_pageFly_topup();
  initAutoTopUpSwitch();
  initAddToCartPremiumStatus();
}

function initAddToCartPremiumStatus() {
  const buyPremiumButton = document.querySelector('#container-' + global_device_type + ' #buy-premium-status');

  if (buyPremiumButton) {
    buyPremiumButton.addEventListener('click', function(event) {
      event.preventDefault();

      const premiumVariantId = 46353063313660;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: premiumVariantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Product added to cart:', data);
        // Optionally redirect to cart:
        window.location.href = '/cart';
      })
      .catch((error) => {
        console.error('Error adding product to cart:', error);
      });
    });
  }
}

/////////////////////////////////////////////////
////  Auto Top-Up Value and Toggle Initialisation
function initAutoTopUpValue_pageFly_topup() {
  const thresholdInputs = document.querySelectorAll("#auto-top-up-block #auto-top-up-threshold input");
  const amountInputs = document.querySelectorAll("#auto-top-up-block #auto-top-up-amount input");

  thresholdInputs.forEach((input) => {
    const syncThreshold = () => {
      const val = parseFloat(input.value);
      thresholdInputs.forEach(inp => inp.value = val);
    };
    input.addEventListener('change', syncThreshold);
    input.addEventListener('input', syncThreshold);
  });

  amountInputs.forEach((input) => {
    const syncAmount = () => {
      const val = parseFloat(input.value);
      amountInputs.forEach(inp => inp.value = val);
    };
    input.addEventListener('change', syncAmount);
    input.addEventListener('input', syncAmount);
  });
}

function initAutoTopUpSwitch() {
  const toggle = document.querySelector('#container-' + global_device_type + ' #toggleSwitch');
  const autoTopupBlock =  document.querySelector('#container-' + global_device_type + ' #auto-top-up-block');
  autoTopupBlock.classList.add('hidden-important');
  const payNowBtn = document.querySelector('#container-' + global_device_type + ' #pay-now');

  if (toggle) {
    toggle.addEventListener('change', (e) => {
      if (e.target.checked && (!customerStripepaymentMethodId && !payNowBtn.classList.contains('enabled'))) {
        e.preventDefault();
        e.target.checked = false;

        const msgId = 'card-warning-msg-auto-topup';
        let msgEl = document.getElementById(msgId);
        if (!msgEl) {
          msgEl = document.createElement('div');
          msgEl.id = msgId;
          msgEl.style.color = '#e53935';
          msgEl.style.fontSize = '14px';
          msgEl.style.marginBottom = '8px';
          autoTopupBlock.parentNode.insertBefore(msgEl, autoTopupBlock);
        }
        msgEl.textContent = 'To enable auto top-up, please enter your card details, then process a payment first.';
        payNowBtn.textContent = 'PAY NOW';
      } else {
        if(e.target.checked) {
          autoTopupBlock.classList.remove('hidden-important');
          autoTopupBlock.classList.add(window.innerWidth <= 320 ? 'block-important' : 'flex-important');
          payNowBtn.textContent = 'PAY NOW & ACTIVATE AUTO TOP-UP';
        } else {
          autoTopupBlock.classList.remove('block-important');
          autoTopupBlock.classList.remove('flex-important');
          autoTopupBlock.classList.add('hidden-important');
          payNowBtn.textContent = 'PAY NOW';
        }
      }
    });
  }
}

//////////////////////////////////
//// Pay Now Button Initialisation
function initPayNowButton() {
  let cardCompleteStatus = {
    number: false,
    expiry: false,
    cvc: false
  };

  if (stripeActiveElements) {
    const cardHolderNameInput = document.querySelector('#container-' + global_device_type + ' #cardholder-name');
    const cardNumberElement = stripeActiveElements.getElement('cardNumber');
    const cardExpiryElement = stripeActiveElements.getElement('cardExpiry');
    const cardCvcElement = stripeActiveElements.getElement('cardCvc');

    cardHolderNameInput.addEventListener('change', (event) => {
      cardInformationUpdateEvt();
    });
    
    cardNumberElement.on('change', (event) => {
      cardCompleteStatus.number = event.complete;
      cardInformationUpdateEvt();
    });

    cardExpiryElement.on('change', (event) => {
      cardCompleteStatus.expiry = event.complete;
      cardInformationUpdateEvt();
    });

    cardCvcElement.on('change', (event) => {
      cardCompleteStatus.cvc = event.complete;
      cardInformationUpdateEvt();
    });

    cardInformationUpdateEvt();
  }

  function cardInformationUpdateEvt() {
    const payNowBtn = document.querySelector('#container-' + global_device_type + ' #pay-now');
    const isSavedCard = typeof customerStripepaymentMethodId === 'string' && customerStripepaymentMethodId.trim() !== '';
    const cardHolderNameInput = document.querySelector('#container-' + global_device_type + ' #cardholder-name');
    const hasCardHolderName = cardHolderNameInput && cardHolderNameInput.value.trim() !== "";
    const isEditableCardValid = cardCompleteStatus.number && cardCompleteStatus.expiry && cardCompleteStatus.cvc && hasCardHolderName;
    const isValidToPay = isSavedCard || isEditableCardValid;

    const autoTopupMsgId = 'card-warning-msg-auto-topup';
    let autoTopupMsgEl = document.getElementById(autoTopupMsgId);
    if(autoTopupMsgEl) autoTopupMsgEl.textContent = '';
    
    const cardWarningMsgId = 'card-warning-msg';
    let cardWarningMsgEl = document.getElementById(cardWarningMsgId);
    if (!cardWarningMsgEl) {
      cardWarningMsgEl = document.createElement('div');
      cardWarningMsgEl.id = cardWarningMsgId;
      cardWarningMsgEl.style.color = '#e53935';
      cardWarningMsgEl.style.fontSize = '14px';
      cardWarningMsgEl.style.marginBottom = '8px';
      payNowBtn.parentNode.insertBefore(cardWarningMsgEl, payNowBtn);
    }

    if (isValidToPay) {
      cardWarningMsgEl.textContent = '';
      payNowBtn.classList.remove('disabled');
      payNowBtn.classList.add('enabled');
      payNowBtn.style.pointerEvents = 'auto';
    } else {
      cardWarningMsgEl.textContent = 'Please enter your card details or use a saved payment method to proceed.';
      payNowBtn.classList.remove('enabled');
      payNowBtn.classList.add('disabled');
      payNowBtn.style.pointerEvents = 'none';
    }
  }

  cardInformationUpdateEvt();
}


////////////////////////////////
//// Top-Up Value Initialisation
function initTopUpValue_pagefly_topup(minVal) {
  const quantityInputs = document.querySelectorAll("#top-up-section input[name='quantity']");
  const STEP = 100;

  quantityInputs.forEach((input) => {
    input.min = minVal;
    input.value = minVal;
    input.step = STEP;

    const container = input.closest('[data-pf-type="ProductQuantity"]');
    if (!container) return;

    const decreaseBtn = container.querySelector('button[data-quantity-action="decrease"]');
    const increaseBtn = container.querySelector('button[data-quantity-action="increase"]');

    const fixValue = () => {
      let val = parseFloat(input.value);
      if (isNaN(val) || val < minVal) val = minVal;

      const offset = val - minVal;
      const rounded = minVal + Math.round(offset / STEP) * STEP;

      document.querySelectorAll("#top-up-section input[name='quantity']").forEach(myinput => {
        myinput.value = rounded;
        myinput.setCustomValidity('');
        if (myinput.offsetParent !== null && !myinput.disabled) {
          myinput.reportValidity();
        }
      });

      if (decreaseBtn) {
        decreaseBtn.disabled = rounded <= minVal;
      }
    };

    input.addEventListener('change', fixValue);
    input.addEventListener('input', fixValue);

    if (increaseBtn) {
      increaseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        let val = parseFloat(input.value) || minVal;
        input.value = val + STEP;
        fixValue();
      });
    }

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        let val = parseFloat(input.value) || minVal;
        input.value = Math.max(minVal, val - STEP);
        fixValue();
      });
    }

    fixValue();
  });
}


//////////////////////////
//// Stripe Initialisation
async function initActionsStripe() {
  const isTestMode = false;
  const PUBLISHABLE_KEY = "pk_live_XsiZLZQjuXqc4Dsb70TlkRiL";
  const PUBLISHABLE_KEY_TEST = "pk_test_51OghvjS3rExfKAGUsnvNUalZuXHQbMy7mcqU3RPjfy9pUhpYrjmERWpRObr6Kjr1S449zk3ForTkREwz2mMIUDYX00ZFenGGey";
  const stripe = Stripe(isTestMode ? PUBLISHABLE_KEY_TEST : PUBLISHABLE_KEY);

  mountStripeCardElements(stripe);
  initPayNowButton();

  if (customerAutoTopUpActive) {
    document.querySelector('#container-' + global_device_type + ' #auto-top-up-stop-head-block').style.display = "block";
    document.querySelector('#container-' + global_device_type + ' #auto-top-up-activate-head-block').style.display = "none";

    document.querySelector('#container-' + global_device_type + ' #stop-top-up-btn').addEventListener('click', async (e) => {
      const originalBtnText = e.target.textContent;
      e.target.textContent = 'Processing...';
      document.getElementById('overlay-text').textContent = '';
      document.getElementById('overlay-buttons').innerHTML = '';
      document.getElementById('loading-overlay').style.display = 'flex';

      addOverlayStatus("Ready to stop automatic top-up payments.");
      await showOverlayButtons("Yes, stop auto top-up", e.target, originalBtnText);

      addOverlayStatus("Stopping auto top-up...");
      const response = await fetch('https://we-wa.com.au/wp-content/themes/golo/inc/stripe_v2/stop_auto_topup.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_email: customerEmail })
      });

      const result = await response.json();
      if (!response.ok || result?.error) {
        addOverlayStatus("Stop auto top-up: " + (result?.error?.message || "Error (contact We Wander at business@wewander.com.au)"));
      } else {
        setTimeout(() => window.location.href = '/', 5000);
      }
    });

  } else {
    document.querySelector('#container-' + global_device_type + ' #auto-top-up-stop-head-block').style.display = "none";
    document.querySelector('#container-' + global_device_type + ' #auto-top-up-activate-head-block').style.display = "flex";
  }

  const payNowBtn = document.querySelector('#container-' + global_device_type + ' #pay-now');

  payNowBtn.addEventListener('click', async () => {
    const originalBtnText = payNowBtn.textContent;
    let hadError = false;

    payNowBtn.disabled = true;
    payNowBtn.textContent = 'Processing...';
    document.getElementById('overlay-text').textContent = '';
    document.getElementById('overlay-buttons').innerHTML = '';
    document.getElementById('loading-overlay').style.display = 'flex';

    try {
      const amountInput = parseFloat(document.querySelector("#top-up-section input[name='quantity']").value);
      if (isNaN(amountInput)) throw new Error("Invalid top-up amount.");

      const amount = Math.round(amountInput * 100);
      const bCardEdited = document.querySelector('#stripe-card-manager-' + global_device_type + ' #edit-card-button')?.getAttribute("data-state") === "EDIT";
      const saveCard = document.getElementById('save-card')?.checked || false;

      const payload = { email: customerEmail, amount, transaction_fees_apply: true };
      if (bCardEdited) payload.save_card = saveCard;

      if (bCardEdited && saveCard) addOverlayStatus("Card saved");
      addOverlayStatus("Ready to process payment.");
      await showOverlayButtons("Yes, process payment", payNowBtn, originalBtnText);
      addOverlayStatus("Processing payment...");

      const response = await fetch('https://we-wa.com.au/wp-content/themes/golo/inc/stripe_v2/create_payment_intent.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const { client_secret, error } = await response.json();
      if (error) throw new Error("Create Payment Intent: " + error);

      let result;
      let paymentMethodId;

      if (!bCardEdited && typeof customerStripepaymentMethodId === 'string') {
        paymentMethodId = customerStripepaymentMethodId;
        result = await stripe.confirmCardPayment(client_secret, {
          payment_method: customerStripepaymentMethodId
        });
      } else {
        const { paymentMethod, error: pmError } = await stripe.createPaymentMethod({
          type: 'card',
          card: stripeActiveElements.getElement('cardNumber'),
          billing_details: { email: customerEmail }
        });
        if (pmError) throw new Error("Create Payment Method: " + pmError.message);
        paymentMethodId = paymentMethod.id;
        result = await stripe.confirmCardPayment(client_secret, { payment_method: paymentMethod.id });
      }

      if (result.error) throw new Error("Payment: " + result.error.message);
      if (result.paymentIntent.status === 'succeeded') addOverlayStatus("Payment processed");

      if (document.querySelector('#container-' + global_device_type + ' #toggleSwitch')?.checked) {
        addOverlayStatus("Ready to activate auto top-up.");
        await showOverlayButtons("Yes, activate auto top-up", payNowBtn, originalBtnText);
        addOverlayStatus("Activating auto top-up...");
        await autoTopUpStripe(paymentMethodId);
        addOverlayStatus("Auto top-up activated");
      }

      if (!hadError) {
        setTimeout(async () => {
          try {
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();
            window.location.href = (cart && cart.items && cart.items.length > 0) ? '/cart' : '/';
          } catch {
            window.location.href = '/';
          }
        }, 5000);
      }

    } catch (err) {
      hadError = true;
      addOverlayStatus("Error: " + err.message + " (please contact We Wander at business@wewander.com.au)");
    } finally {
      payNowBtn.disabled = false;
      payNowBtn.textContent = originalBtnText;
      if (hadError) {
        addOverlayStatus("Please refresh the page and try again.");
      } else {
        setTimeout(() => {
          document.getElementById('loading-overlay').style.display = 'none';
        }, 6000);
      }
    }
  });
}

/////////////////////////////////////////////////////
//// Stripe Card Mounting and Auto Top-Up Activation
function mountStripeCardElements(stripe) {
  const elementsDesktop = stripe.elements();
  const elementsMobile = stripe.elements();

  const style = {
    base: {
      fontSize: '16px',
      color: '#32325d',
      '::placeholder': { color: '#aab7c4' }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  };

  const cardNumberDesktop = elementsDesktop.create('cardNumber', {
    style,
    placeholder: customerStripeCardLast4 ? '**** **** **** ' + customerStripeCardLast4 : undefined
  });

  const cardNumberMobile = elementsMobile.create('cardNumber', {
    style,
    placeholder: customerStripeCardLast4 ? '**** **** **** ' + customerStripeCardLast4 : undefined
  });

  const cardExpiryDesktop = elementsDesktop.create('cardExpiry');
  const cardCvcDesktop = elementsDesktop.create('cardCvc');
  const cardExpiryMobile = elementsMobile.create('cardExpiry');
  const cardCvcMobile = elementsMobile.create('cardCvc');

  let currentView = null;

  function unmountAll() {
    try {
      cardNumberDesktop.unmount(); cardExpiryDesktop.unmount(); cardCvcDesktop.unmount();
    } catch {}
    try {
      cardNumberMobile.unmount(); cardExpiryMobile.unmount(); cardCvcMobile.unmount();
    } catch {}
  }

  function mountCardForm() {
    const isDesktop = window.innerWidth >= 768;
    const newView = isDesktop ? 'desktop' : 'mobile';
    if (currentView === newView) return;

    unmountAll();

    if (isDesktop) {
      cardNumberDesktop.mount('#card-number-element-desktop');
      cardExpiryDesktop.mount('#card-expiry-element-desktop');
      cardCvcDesktop.mount('#card-cvc-element-desktop');
      stripeActiveElements = elementsDesktop;
    } else {
      cardNumberMobile.mount('#card-number-element-mobile');
      cardExpiryMobile.mount('#card-expiry-element-mobile');
      cardCvcMobile.mount('#card-cvc-element-mobile');
      stripeActiveElements = elementsMobile;
    }

    currentView = newView;
  }

  mountCardForm();

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(mountCardForm, 300);
  });
}

async function autoTopUpStripe(payment_method) {
  if (!payment_method) throw new Error("No payment method available to save for auto top-up.");

  const thresholdInput = document.querySelector("#auto-top-up-block #auto-top-up-threshold input");
  const amountInput = document.querySelector("#auto-top-up-block #auto-top-up-amount input");

  if (!thresholdInput || !amountInput) {
    throw new Error("Missing auto top-up inputs.");
  }

  const thresholdAmount = Math.round(parseFloat(thresholdInput.value) * 100);
  const autoTopUpAmount = Math.round(parseFloat(amountInput.value) * 100);

  const response = await fetch('https://we-wa.com.au/wp-content/themes/golo/inc/stripe_v2/activate_auto_topup.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      customer_email: customerEmail,
      payment_method,
      auto_top_up_amount: autoTopUpAmount,
      threshold_amount: thresholdAmount
    })
  });

  const result = await response.json();
  if (!response.ok || result?.error) {
    throw new Error(result?.error || 'Unknown error while saving auto top-up settings.');
  }
}
